import React from 'react'
import PropTypes from 'prop-types'
import { GradeListWrapper, StyledGradeProgressData } from './component.styles'

const AdminGradeList = ({
  dwbProgressBars,
  grades,
  siteId,
  splitTwoColumns,
}) => {
  const gradeCount = grades?.length ?? 0
  return (
    <GradeListWrapper gradeCount={gradeCount} splitTwoColumns={splitTwoColumns}>
      {grades?.map(grade => {
        const {
          classesNotStarted,
          lessonsCompleted,
          name,
          numOfClasses,
          totalLessons,
        } = grade
        return (
          <StyledGradeProgressData
            classesNotStarted={classesNotStarted}
            dwbProgressBars={dwbProgressBars}
            grade={name}
            key={`grade-${name}-progress`}
            lessonsCompleted={lessonsCompleted}
            numOfClasses={numOfClasses}
            siteId={siteId}
            totalLessons={totalLessons}
          />
        )
      })}
    </GradeListWrapper>
  )
}

AdminGradeList.propTypes = {
  dwbProgressBars: PropTypes.bool,
  grades: PropTypes.array,
  siteId: PropTypes.number,
  splitTwoColumns: PropTypes.bool,
}

export default AdminGradeList
